import { InstallationReportStatus } from '../../installation-reporting-app/entities/installation-reporting-entities';
import { SectionStatusStatuses } from '../../installation-reporting-app/entities/installation-reporting-mdu.entities';
import { StatusStyleMap } from './status-style.entities';
import {
  activeBasicStatusStyle,
  cautionBasicStatusStyle,
  criticalBasicStatusStyle,
  criticalStatusStyle,
  inactiveStatusStyle,
  inProgressStatusStyle,
  pendingStatusStyle,
  successStatusStyle,
  successStrikeThroughStatusStyle,
} from './status-style.styles';

//Installation Reporting App

export const GroupAgreementOrderStatusStyle: StatusStyleMap<InstallationReportStatus> =
  {
    ORDERED: activeBasicStatusStyle,
    ORDERED_FOR_BUILD: activeBasicStatusStyle,
    CANCELLED: criticalBasicStatusStyle,
    REVOKED: criticalBasicStatusStyle,
    WITHDRAWN: criticalBasicStatusStyle,
    ESCALATED: cautionBasicStatusStyle,
    CONSTRUCTION_DEVIATION: cautionBasicStatusStyle,
    NOT_VALIDATED: cautionBasicStatusStyle,
    WARNING: cautionBasicStatusStyle,
    INSTALLED: activeBasicStatusStyle,
  };

export const SectionStatusStyle: StatusStyleMap<SectionStatusStatuses> = {
  NOT_STARTED: inactiveStatusStyle,
  INCOMPLETE: criticalStatusStyle,
  IN_PROGRESS: inProgressStatusStyle,
  DONE: successStatusStyle,
  EXECUTED: successStatusStyle,
  PLANNED: pendingStatusStyle,
  NOT_APPLICABLE: successStrikeThroughStatusStyle,
};

export const ConstructionStatusStyle: StatusStyleMap<string> = {
  PLANNED: pendingStatusStyle,
  HANDED_TO_CONSTRUCTION: activeBasicStatusStyle,
  STARTED: inProgressStatusStyle,
  FINISHED: successStatusStyle,
  OBSTRUCTION: criticalStatusStyle,
  MIGRATION_ONGOING: inProgressStatusStyle,
  MIGRATED: successStatusStyle,
};
